<template>
  <div>
    <span
      :class="[
        'bmd-form-group mb-2 mt-2 d-block form-label-group',
        country_focused ? 'focused' : '',
      ]"
    >
      <v-select-popup
        type="country"
        :placeholder="$t('message.contracts.country')"
        v-model="country"
      />

      <!-- <v-select id="ap_main_country_code" :options="countries" label="display_text" :class="['form-control', typeof country !== 'undefined' && country.value!==''?'vs--selected':'']" @search=fetchCountries v-model="country" :placeholder="$t('message.contracts.country')" @focus="country_focused = true" @blur="country_focused = false"></v-select>	
            <label for="ap_main_country_code" class="form-label-group-label shorter">{{$t('message.contracts.country')}}</label> -->
    </span>
    <div class="row">
      <div class="col-12 col-md-4">
        <h3>{{ $t("message.contracts.customs_organs") }}</h3>
        <div v-if="country.value == 'KZ'">
          <div>
            <button class="btn btn-default" @click="astana_1">
              {{ $t("message.contracts.customs_xml_astana_1") }}
            </button>
          </div>
          <div>
            <button class="btn btn-default" @click="xlsx_d_selector">
              {{ $t("message.contracts.customs_xlsx_d_selector") }}
            </button>
          </div>
          <div>
            <button
              class="btn btn-default"
              @click="wsdl_astana"
              :disabled="is_utin"
            >
              {{ $t("message.contracts.customs_wsdl_astana") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <h3>{{ $t("message.contracts.transport_organs") }}</h3>
        <div v-if="country.value == 'KZ'">
          <div>
            <button class="btn btn-default" @click="ktzh">
              {{ $t("message.contracts.transport_ktzh") }}
            </button>
          </div>
          <div>
            <button class="btn btn-default" @click="auto">
              {{ $t("message.contracts.transport_auto") }}
            </button>
          </div>
          <div>
            <button class="btn btn-default" @click="avia">
              {{ $t("message.contracts.transport_avia") }}
            </button>
          </div>
          <div>
            <button class="btn btn-default" @click="water">
              {{ $t("message.contracts.transport_water") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <h3>{{ $t("message.contracts.governmental_organs") }}</h3>
        <div v-if="country.value == 'KZ'">
          <div class="form-group">
            <select v-model="governmental_organ" class="form-control">
              <option value="">
                {{ $t("message.contracts.governmental_organs_make_choise") }}
              </option>
              <option value="tax">
                {{ $t("message.contracts.governmental_organs_tax") }}
              </option>
              <option value="certification">
                {{ $t("message.contracts.governmental_organs_certification") }}
              </option>
              <option value="fin_monitoring">
                {{ $t("message.contracts.governmental_organs_fin_monitoring") }}
              </option>
              <option value="customs">
                {{ $t("message.contracts.governmental_organs_customs") }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-xml-astana"
      :title="
        $t('message.contracts.customs_xml_astana_1_title').replace(
          '{contract_id}',
          contract_id,
        )
      "
      :hide-footer="true"
      button-size="lg"
    >
      <button class="btn btn-default mr-3" @click="make_xml_astana_1">
        {{ $t("message.contracts.make_xml_file") }}
      </button>
      <a :href="astana_1_file" target="_blank" v-if="astana_1_file != ''"
        ><i class="fa fa-file"></i> XML</a
      >
    </b-modal>
    <b-modal
      id="modal-xlsx-d-selector"
      :title="
        $t('message.contracts.customs_xlsx_d_selector_title').replace(
          '{contract_id}',
          contract_id,
        )
      "
      :hide-footer="true"
      button-size="lg"
    >
      <button class="btn btn-default mr-3" @click="make_xlsx_d_selector">
        {{ $t("message.contracts.make_xlsx_file") }}
      </button>
      <a :href="d_selector_file" target="_blank" v-if="d_selector_file != ''"
        ><i class="fa fa-file"></i> XLSX</a
      >
    </b-modal>
    <b-modal
      id="modal-wsdl-astana"
      :title="
        $t('message.contracts.customs_wsdl_astana_title').replace(
          '{contract_id}',
          contract_id,
        )
      "
      :hide-footer="true"
      button-size="lg"
    >
      <button class="btn btn-default mr-3" @click="send_request_to_astana_1">
        {{ $t("message.contracts.send_data_to_astana_1") }}
      </button>
      <div class="form-group" v-if="astana_1_answer != ''">
        <label>{{ $t("message.contracts.astana_1_answer") }}</label>
        <textarea
          readonly
          v-model="astana_1_answer"
          class="form-control"
        ></textarea>
      </div>
    </b-modal>
    <b-modal
      id="modal-ktzh_upload"
      :size="'sm'"
      :title="$t('message.contracts.upload_ktzh_answer')"
      :hide-footer="true"
      button-size="sm"
    >
      <input type="file" @change="hangle_file_ktzh" />
    </b-modal>
    <b-modal
      id="modal-ktzh"
      :size="'lg'"
      :title="ktzh_title.replace('{contract_id}', contract_id)"
      :hide-footer="true"
      button-size="lg"
    >
      <div v-if="!is_view_ktzh && !is_make_ktzh">
        <b-table
          responsive
          striped
          hover
          :items="ktzh_log"
          :fields="ktzh_log_fields"
        >
          <!-- <template v-slot:cell(name)="data">
                        <a class="btn btn-link p-0" :href="'/contract/FileDownloadSFTP/?file='+data.value+'&contract_id='+contract_id" target="_blank"><i class="fa fa-file"></i></a>
                    </template> -->
          <template v-slot:cell(date)="data">
            {{ momentum(data.value) }}
          </template>
          <template v-slot:cell(type)="data">
            {{ $t("message.contracts.ktzh_log_type_" + data.item.type) }}
          </template>
          <template v-slot:cell(action)="data">
            <button
              class="btn btn-link p-0"
              @click="show_ktzh(data.item)"
              :title="$t('message.contracts.show_ktzh_request')"
            >
              <i class="fa fa-search"></i>
            </button>
            <button
              v-if="!check_data_type(data.item.response, 'boolean')"
              :title="$t('message.contracts.show_ktzh_answer')"
              class="btn btn-link p-0 ml-3"
              @click="show_ktzh(data.item.response)"
            >
              <i class="fa fa-eye"></i>
            </button>
            <button
              v-if="isAdmin || is_owner"
              :title="$t('message.contracts.upload_ktzh_answer')"
              class="btn btn-link p-0 ml-3"
              @click="show_ktzh_upload_answer(data.item)"
            >
              <i class="fa fa-upload"></i>
            </button>
          </template>
        </b-table>
        <button class="btn btn-default mr-3" @click="make_ktzh_request">
          {{ $t("message.contracts.make_ktzh_request") }}
        </button>
      </div>
      <div v-if="is_view_ktzh">
        <div class="mb-3">
          <button
            class="btn btn-outline-secondary btn-sm"
            @click="is_view_ktzh = false"
          >
            <i class="fa fa-arrow-left mr-1"></i> {{ $t("message.back") }}
          </button>
        </div>
        <div v-if="viewing_ktzh.type == 'request'">
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_for_date") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="momentum(viewing_ktzh.date)"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_bin") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.bin"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_movement_type") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="
                $t(
                  'message.contracts.ktzh_movement_' +
                    viewing_ktzh.movement_type,
                )
              "
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_participant_type") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="
                $t(
                  'message.contracts.ktzh_participant_' +
                    viewing_ktzh.participant_type,
                )
              "
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_expeditor_code") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.expeditor"
            />
          </div>
        </div>
        <div v-else>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_invoice_un") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.invoice_un"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_invoice_num") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.invoice_num"
            />
          </div>
          <div class="form-group">
            <label>{{
              $t("message.contracts.ktzh_recive_station_code")
            }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.recive_station_code"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_dest_station_code") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.dest_station_code"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_sender_exp_no") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.sender_exp_no"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_etsng_code") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.etsng_code"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_fact_mass") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.fact_mass"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_payer_code") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.payer_code"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_vag_no") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.vag_no"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_vag_count") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.vag_count"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_gruz") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.gruz"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_invc_dt") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.date"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_container_no") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.container_no"
            />
          </div>
          <div class="form-group">
            <label>{{ $t("message.contracts.ktzh_smgs_type") }}</label>
            <input
              type="text"
              class="form-control"
              readonly
              :value="viewing_ktzh.smgs_type"
            />
          </div>
        </div>
      </div>
      <div v-if="is_make_ktzh">
        <div class="mb-3">
          <button
            class="btn btn-outline-secondary btn-sm"
            @click="is_make_ktzh = false"
          >
            <i class="fa fa-arrow-left mr-1"></i> {{ $t("message.cancel") }}
          </button>
        </div>
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <!-- <b-form-datepicker :locale="locale" v-model="ktzh_request.for_date" :placeholder="$t('message.contracts.ktzh_for_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker>
                    <label for="ktzh_for_date"   v-if="ktzh_request.for_date!=''"  class="form-label-group-label shorter topped">{{$t('message.contracts.ktzh_for_date')}}</label> -->

          <datepicker
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="ktzh_request.for_date = ' '"
            @blur="
              ktzh_request.for_date == ' '
                ? (ktzh_request.for_date = '')
                : (ktzh_request.for_date = ktzh_request.for_date)
            "
            inputClass="form-control"
            :disabled="is_field_readonly"
            v-model="ktzh_request.for_date"
            :placeholder="$t('message.contracts.ktzh_for_date')"
            :inputAttr="{ id: 'ktzh_for_date' }"
          />
          <label
            for="ktzh_for_date"
            class="form-label-group-label shorter"
            :class="
              ktzh_request.for_date != '' && ktzh_request.for_date != null
                ? 'topped'
                : ''
            "
            >{{ $t("message.contracts.ktzh_for_date") }}</label
          >
        </span>
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ktzh_request.bin"
            :placeholder="$t('message.contracts.ktzh_bin')"
            autocomplete="off"
            style="cursor: auto"
            id="ktzh_bin"
          />
          <label for="ktzh_bin" class="form-label-group-label shorter">{{
            $t("message.contracts.ktzh_bin")
          }}</label>
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            movement_type_focused ? 'focused' : '',
          ]"
        >
          <v-select-popup
            :indata="movement_types"
            :placeholder="$t('message.contracts.ktzh_movement_type')"
            v-model="ktzh_request.movement_type"
          />
          <!-- <v-select id="movement_type" :options="movement_types" label="display_text" :class="['form-control', typeof ktzh_request.movement_type !== 'undefined' && ktzh_request.movement_type.value!==''?'vs--selected':'']" v-model="ktzh_request.movement_type" :placeholder="$t('message.contracts.ktzh_movement_type')" @focus="movement_type_focused = true" @blur="movement_type_focused = false"></v-select>	
                    <label for="movement_type" class="form-label-group-label shorter">{{$t('message.contracts.ktzh_movement_type')}}</label> -->
        </span>
        <span
          :class="[
            'bmd-form-group mb-2 mt-2 d-block form-label-group',
            participant_type_focused ? 'focused' : '',
          ]"
        >
          <v-select-popup
            :indata="participant_types"
            :placeholder="$t('message.contracts.ktzh_participant_type')"
            v-model="ktzh_request.participant_type"
          />
          <!-- <v-select id="participant_type" :options="participant_types" label="display_text" :class="['form-control', typeof ktzh_request.participant_type !== 'undefined' && ktzh_request.participant_type.value!==''?'vs--selected':'']" v-model="ktzh_request.participant_type" :placeholder="$t('message.contracts.ktzh_participant_type')" @focus="participant_type_focused = true" @blur="participant_type_focused = false"></v-select>	
                    <label for="participant_type" class="form-label-group-label shorter">{{$t('message.contracts.ktzh_participant_type')}}</label> -->
        </span>
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="ktzh_request.expeditor_code"
            :placeholder="$t('message.contracts.ktzh_expeditor_code')"
            autocomplete="off"
            style="cursor: auto"
            id="ktzh_expeditor_code"
          />
          <label
            for="ktzh_expeditor_code"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.ktzh_expeditor_code") }}</label
          >
        </span>
        <button class="btn btn-success" @click="ktzh_send_request">
          {{ $t("message.contracts.ktzh_send_request") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
var FileSaver = require("file-saver");
import moment from "moment";
export default {
  props: {
    contract_id: String,
    is_owner: Boolean,
  },
  data() {
    return {
      viewing_ktzh: {},
      countries: [],
      country: { value: "KZ", display_text: "" },
      country_focused: false,
      governmental_organ: "",
      d_selector_file: "",
      astana_1_file: "",
      astana_1_answer: "",
      current_company: {},
      ktzh_log: [],
      ktzh_log_fields: [
        // {
        //     key: "id",
        //     label: this.$t('message.contracts.ktzh_log_id')
        // },
        {
          key: "type",
          label: this.$t("message.contracts.ktzh_log_type"),
        },
        {
          key: "date",
          label: this.$t("message.contracts.ktzh_log_date"),
        },
        // {
        //     key: "name",
        //     label: this.$t('message.contracts.ktzh_log_file')
        // },
        {
          key: "action",
          label: this.$t("message.contracts.ktzh_log_action"),
        },
      ],
      is_view_ktzh: false,
      is_make_ktzh: false,
      ktzh_request: {
        for_date: "",
        bin: "",
        movement_type: { value: "", display_text: "" },
        participant_type: { value: "", display_text: "" },
        expeditor_code: "",
      },
      movement_type_focused: false,
      movement_types: [
        {
          value: 1,
          display_text: this.$t("message.contracts.ktzh_movement_1"),
        },
        {
          value: 2,
          display_text: this.$t("message.contracts.ktzh_movement_2"),
        },
        {
          value: 3,
          display_text: this.$t("message.contracts.ktzh_movement_3"),
        },
        {
          value: 4,
          display_text: this.$t("message.contracts.ktzh_movement_4"),
        },
        {
          value: 5,
          display_text: this.$t("message.contracts.ktzh_movement_5"),
        },
      ],
      participant_type_focused: false,
      participant_types: [
        {
          value: 0,
          display_text: this.$t("message.contracts.ktzh_participant_0"),
        },
        {
          value: 1,
          display_text: this.$t("message.contracts.ktzh_participant_1"),
        },
        {
          value: 2,
          display_text: this.$t("message.contracts.ktzh_participant_2"),
        },
      ],
      current_ktzh_for_upload: {},
      is_utin: false,
    };
  },
  mounted() {
    this.fetchCountries("");
    // this.fetchMovementTypes('')
    // this.fetchParticipantTypes('')
    axios.get(window.base + "/document/getfirm").then((response) => {
      this.current_company = response.data;
      if (this.contract_id) {
        axios
          .get(
            window.base +
              "/document/CheckAstanaUTIN?contract_id=" +
              this.contract_id,
          )
          .then((resp) => {
            if (resp.data.message == "True") {
              this.is_utin = true;
            }
          });
      }
    });
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.role_id == 63;
    },
    ktzh_title() {
      if (this.is_make_ktzh)
        return this.$t("message.contracts.transport_ktzh_make_title");
      else if (this.is_view_ktzh) {
        if (this.viewing_ktzh.type == "request")
          return this.$t("message.contracts.transport_ktzh_view_title");
        else return this.$t("message.contracts.transport_ktzh_view_resp_title");
      } else return this.$t("message.contracts.transport_ktzh_title");
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  methods: {
    hangle_file_ktzh(event) {
      let fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append(
        "request_id",
        this.current_ktzh_for_upload.id ? this.current_ktzh_for_upload.id : 0,
      );
      axios
        .post(window.base + "/contract/ktzh_response_upload", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.$bvModal.hide("modal-ktzh_upload");
          this.ktzh_load();
        });
    },
    show_ktzh_upload_answer(item) {
      this.$bvModal.show("modal-ktzh_upload");
      this.current_ktzh_for_upload = item;
    },
    momentum(date) {
      // return date
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    astana_1() {
      this.$bvModal.show("modal-xml-astana");
    },
    make_xml_astana_1() {
      // document/xmlastana1?id=242
      axios
        .get(window.base + "/contract/xmlastana1?id=" + this.contract_id)
        .then((response) => {
          var blob = new Blob([response.data], { type: "text/xml" });
          FileSaver.saveAs(blob, "astana_1.xml");
          // if(response.data.status == 200){
          //     this.astana_1_file = response.data.file
          //     new Noty({
          //         theme: 'light',
          //         type: 'success',
          //         text: this.$root.$t('message.message.astana_1_ok'),
          //         timeout: 5000,
          //     }).show();
          // }else{
          //     new Noty({
          //         theme: 'light',
          //         type: 'error',
          //         text: this.$root.$t('message.message.astana_1_nok')+' ('+response.data.message+')',
          //         timeout: 5000,
          //     }).show();
          // }
        });
    },
    xlsx_d_selector() {
      this.$bvModal.show("modal-xlsx-d-selector");
    },
    make_xlsx_d_selector() {
      axios
        .get(
          window.base + "/contract/d_selector?contract_id=" + this.contract_id,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.d_selector_file = response.data.file;
            window.location.href = this.d_selector_file;
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.d_selector_ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.d_selector_nok") +
                " (" +
                response.data.message +
                ")",
              timeout: 5000,
            }).show();
          }
        });
    },
    wsdl_astana() {
      this.$bvModal.show("modal-wsdl-astana");
    },
    send_request_to_astana_1() {
      axios
        .get(window.base + "/document/SBRequest?contractId=" + this.contract_id)
        .then((response) => {
          if (response.data.status == 100) {
            this.astana_1_answer = response.data.message;
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.wsdl_astana_1_ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.wsdl_astana_1_nok") +
                " (" +
                response.data.message +
                ")",
              timeout: 5000,
            }).show();
          }
        });
    },
    check_data_type(i, type) {
      return typeof i === type;
    },
    ktzh() {
      this.$bvModal.show("modal-ktzh");
      this.ktzh_load();
    },
    ktzh_load() {
      axios
        .get(window.base + "/contract/ktzh_log?contract_id=" + this.contract_id)
        .then((response) => {
          this.ktzh_log = [];
          this.ktzh_log = this.ktzh_log.concat(
            response.data.map((item) => {
              item.type = "request";
              item.response = false;
              if (typeof item.id == "undefined") item.id = 0;
              var d = moment(item.for_date);
              if (d.isValid())
                item.date = moment(item.for_date).format("YYYY-MM-DD HH:mm");
              else
                item.date = moment(item.for_date, "DD.MM.YYYY HH:mm:ss").format(
                  "YYYY-MM-DD HH:mm",
                );
              return item;
            }),
          );
          this.ktzh_log.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            var d1 = moment(b.date);
            var d2 = moment(a.date);

            return d1 - d2;
          });
          axios
            .get(
              window.base +
                "/contract/ktzh_log_resp?contract_id=" +
                this.contract_id,
            )
            .then((res) => {
              res.data.forEach((item) => {
                this.ktzh_log.forEach((log, i) => {
                  if (typeof item.request_id == "undefined")
                    item.request_id = 0;
                  console.log(log, item);
                  if (log.id == item.request_id) {
                    this.$set(this.ktzh_log[i], "response", item);
                  }
                });
              });
              // this.ktzh_log = this.ktzh_log.concat(res.data.map(item=>{
              //     item.type='response'
              //     var d = moment(item.for_date);
              //     if(d.isValid())
              //         item.date = moment(item.invc_dt).format('YYYY-MM-DD HH:mm')
              //     else
              //         item.date = moment(item.invc_dt, 'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm')
              //     return item
              // }))
              this.ktzh_log.sort(function (a, b) {
                // Turn your strings into dates, and then subtract them
                // to get a value that is either negative, positive, or zero.
                var d1 = moment(b.date);
                var d2 = moment(a.date);

                return d1 - d2;
              });
            });
        });
    },
    show_ktzh(ktzh) {
      this.viewing_ktzh = ktzh;
      this.is_view_ktzh = true;
    },
    make_ktzh_request() {
      this.is_make_ktzh = true;
      this.ktzh_request.bin = this.current_company.org_code;
    },
    ktzh_send_request() {
      var fd = new FormData();
      fd.append("for_date", this.ktzh_request.for_date);
      fd.append("bin", this.ktzh_request.bin);
      fd.append("movement_type", this.ktzh_request.movement_type.value);
      fd.append("participant_type", this.ktzh_request.participant_type.value);
      fd.append("expeditor", this.ktzh_request.expeditor_code);
      axios
        .post(
          window.base +
            "/contract/post_ktzh_sftp?contract_id=" +
            this.contract_id,
          fd,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.is_make_ktzh = false;
            this.ktzh_load();
            this.ktzh_request = {
              bin: this.current_company.org_code,
              for_date: "",
              movement_type: { value: "" },
              participant_type: { value: "" },
              expeditor_code: "",
            };
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.ktzh_sftp_ok"),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.ktzh_sftp_nok") +
                " (" +
                response.data.message +
                ")",
              timeout: 5000,
            }).show();
          }
        });
    },
    auto() {},
    avia() {},
    water() {},
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },
    fetchMovementTypes(search, loading) {
      this.getLibrary("movement_type", search, 100);
    },
    fetchParticipantTypes(search, loading) {
      this.getLibrary("participant_type", search, 100);
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
  },
};
</script>
